import { type ProConRelationshipId, type SuretyAccountId } from "@inrev/common";
import { useRequest } from "../../../utils/request";
import { proConRelationshipsQueryKey } from "../decisioning.keys";
import { type ProConRelationship } from "../types";
import { useOptimisticListMutation } from "../useOptimisticListMutation";

export const useDeleteProConRelationship = (accountId: SuretyAccountId) => {
	const { _delete } = useRequest();

	const mutation = useOptimisticListMutation<ProConRelationship, ProConRelationshipId>({
		queryKey: proConRelationshipsQueryKey(accountId),
		request: async (id) => {
			await _delete(
				`/v2/admin/surety/accounts/${accountId}/pro-con-relationships/${id}`,
				undefined,
				"none",
			);
		},
		apply: (items, id) => items.filter((item) => item.id !== id),
		affectedIds: (id) => [id],
		failureMessage: () => "Couldn't remove the connection.",
	});

	return {
		deleteRelationship: mutation.mutate,
	};
};
